import { c as _c } from "react/compiler-runtime";
import './supporter-identity.scss';
import { useTranslation } from 'react-i18next';
import { cn } from '@sola/ark-core/utils/helpers.ts';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { InitialsAvatar } from '../../atoms/initials-avatar/initials-avatar';
export const SupporterIdentity: React.FC<{
  variant: 'full' | 'minimal' | 'dropdown' | 'loggedOut';
  size?: 'sm' | 'md' | 'lg';
  name?: string;
  initials?: string;
  email?: string;
  notificationCount?: number;
  className?: string;
}> = t0 => {
  const $ = _c(43);
  const {
    variant,
    size,
    name,
    email,
    notificationCount,
    initials,
    className
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["priority"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  if (variant === "minimal") {
    let t2;
    if ($[1] !== className) {
      t2 = cn("SupporterIdentity", className);
      $[1] = className;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== initials || $[4] !== notificationCount || $[5] !== size) {
      t3 = <InitialsAvatar initials={initials} notificationCount={notificationCount} size={size} />;
      $[3] = initials;
      $[4] = notificationCount;
      $[5] = size;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== t2 || $[8] !== t3) {
      t4 = <div className={t2}>{t3}</div>;
      $[7] = t2;
      $[8] = t3;
      $[9] = t4;
    } else {
      t4 = $[9];
    }
    return t4;
  }
  if (variant === "dropdown") {
    let t2;
    if ($[10] !== className) {
      t2 = cn("SupporterIdentity SupporterIdentity--dropdown flex flex-row gap-snug-xl items-center", className);
      $[10] = className;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    let t3;
    if ($[12] !== initials || $[13] !== size) {
      t3 = <InitialsAvatar initials={initials} size={size} />;
      $[12] = initials;
      $[13] = size;
      $[14] = t3;
    } else {
      t3 = $[14];
    }
    let t4;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <ArkIcon iconName="chevron-down" className="lg:hidden" />;
      $[15] = t4;
    } else {
      t4 = $[15];
    }
    let t5;
    if ($[16] !== t2 || $[17] !== t3) {
      t5 = <div className={t2}>{t3}{t4}</div>;
      $[16] = t2;
      $[17] = t3;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    return t5;
  }
  if (variant === "loggedOut") {
    let t2;
    if ($[19] !== className) {
      t2 = cn("SupporterIdentity SupporterIdentity--loggedOut relative flex flex-row gap-snug-md items-center label-md label-potent", className);
      $[19] = className;
      $[20] = t2;
    } else {
      t2 = $[20];
    }
    let t3;
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <ArkIcon iconName="user-01" />;
      $[21] = t3;
    } else {
      t3 = $[21];
    }
    let t4;
    if ($[22] !== t) {
      t4 = t("priority:header.logIn");
      $[22] = t;
      $[23] = t4;
    } else {
      t4 = $[23];
    }
    let t5;
    if ($[24] !== t2 || $[25] !== t4) {
      t5 = <div className={t2}>{t3}{t4}</div>;
      $[24] = t2;
      $[25] = t4;
      $[26] = t5;
    } else {
      t5 = $[26];
    }
    return t5;
  }
  let t2;
  if ($[27] !== className) {
    t2 = cn("SupporterIdentity flex gap-comfy-xs px-comfy-sm lg:px-comfy-xs", className);
    $[27] = className;
    $[28] = t2;
  } else {
    t2 = $[28];
  }
  let t3;
  if ($[29] !== initials || $[30] !== notificationCount) {
    t3 = <InitialsAvatar initials={initials} size="md" notificationCount={notificationCount} />;
    $[29] = initials;
    $[30] = notificationCount;
    $[31] = t3;
  } else {
    t3 = $[31];
  }
  let t4;
  if ($[32] !== name) {
    t4 = name && <p className="SupporterIdentity__name label-md label-potent overflow-hidden m-0 text-wrap-nowrap text-ellipsis">{name}</p>;
    $[32] = name;
    $[33] = t4;
  } else {
    t4 = $[33];
  }
  let t5;
  if ($[34] !== email) {
    t5 = email && <p className="SupporterIdentity__email label-md label-moderate overflow-hidden text-wrap-nowrap text-ellipsis">{email}</p>;
    $[34] = email;
    $[35] = t5;
  } else {
    t5 = $[35];
  }
  let t6;
  if ($[36] !== t4 || $[37] !== t5) {
    t6 = <div className="flex flex-col overflow-hidden justify-center">{t4}{t5}</div>;
    $[36] = t4;
    $[37] = t5;
    $[38] = t6;
  } else {
    t6 = $[38];
  }
  let t7;
  if ($[39] !== t2 || $[40] !== t3 || $[41] !== t6) {
    t7 = <div className={t2}>{t3}{t6}</div>;
    $[39] = t2;
    $[40] = t3;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  return t7;
};